// Internal Module Imports
import { BASE_URL_BIDDING_SERVICE } from '../../../constants';
import { HttpClient } from '../../../utils/httpClient';

const PATH = {
    get: `/${BASE_URL_BIDDING_SERVICE}/admin/economics`,
    getLedger: `/${BASE_URL_BIDDING_SERVICE}/admin/economics/ledger`,
    getConsumption: `/${BASE_URL_BIDDING_SERVICE}/admin/economics/consumption`,
    fixedChargers: `/admin/economics/fixed-chargers`,
    scSavingLedgerData: `/admin/economics/sc-saving-ledger`,
    scSavingOverviewData: `/${BASE_URL_BIDDING_SERVICE}/admin/economics/sc-saving-overview`,
};

const GetEconomics = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.get}`, { params }).then(callback).catch(error).finally(next);
};

const GetLedgerData = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.getLedger}`, { params }).then(callback).catch(error).finally(next);
};

const GetConsumption = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.getConsumption, { params }).then(callback).catch(error).finally(next);
};

const GetFixedChargersRevenue = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.fixedChargers, { params }).then(callback).catch(error).finally(next);
};

const GetSCSavingLedgerData = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.scSavingLedgerData, { params }).then(callback).catch(error).finally(next);
};

const GetSCSavingOverviewData = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.scSavingOverviewData, { params }).then(callback).catch(error).finally(next);
};

export const AdminEconomicsService = {
    GetEconomics,
    GetLedgerData,
    GetConsumption,
    GetFixedChargersRevenue,
    GetSCSavingLedgerData,
    GetSCSavingOverviewData,
};
